<template lang='pug'>
.options
  .col-md-12
    a.close-icon(href='#' @click='closeOptions')
      i.fal.fa-fw.fa-times
    h4
      i.fas.fa-cog
      | &nbsp; {{ options.title }} Settings
    ed-form(:submit-visible='false')
      //- Options
      .option-group(v-for='(option, i) in availableSettings', :key='i'
                    v-if='option.placement === placeholders.settings'
      )
        p.option-label(v-if='option.label && relevantToDisplay(option)') #[strong {{ option.label }}]
        component.inline.stretch.list.col-md-7(:is='optionComponent(option.type)'
                  v-if='option.type === "currencySelector"'
                  :name='option.name'
                  :options='currencies'
                  :placeholder='getValue(i, "currencies")'
                  label='label'
                  track-by='key'
                  v-model='settings[i].value'
                  @select='setValue($event, i)'
        )
        component.inline.stretch.list.col-md-7(:is='optionComponent(option.type)'
                  v-if='relevantToDisplay(option) && option.type !== "currencySelector"'
                  :name='option.name'
                  :options='option.items'
                  :placeholder='getValue(i)'
                  label='label'
                  track-by='key'
                  v-model='settings[i].value'
                  @select='setValue($event, i)'
        )
        .clear
      //- Report Filters
      .option-group
        p.option-label(v-if='_value.reportFilters && _value.reportFilters.length > 0') #[strong Report Settings]
          ul
            li(v-for='(item, i) in _value.reportFilters', :key='i')
              span {{item.key}}: {{item.value}}
  .clear
  .text-center
    ed-button(@click='set' :endpoint='operations.savePending && endpoint') Save Widget
    // ed-button.btn-secondary(@click='clone' :endpoint='operations.clonePending && endpoint') Duplicate Widget
    // ed-button.btn-border.btn-white(@click='remove' :endpoint='operations.deletePending && endpoint') Delete Widget
</template>

<script>

import { WIDTHS, SELECTOR_COMPONENTS, SETTING_PLACEHOLDERS } from './constants'
import LayoutSnippet from '@/components/Layouts/snippets/columns'
import Vue from 'vue'
import { EventBus } from '@/event-bus'

export default {
  props: ['options', 'value'],
  components: {
    LayoutSnippet
  },

  beforeCreate() {
    this.defaultModuleWidthOptions = [
      { label: '100%', value: 12 },
      { label: '66%', value: 8 },
      { label: '50%', value: 6 },
      { label: '33%', value: 4 }
    ]
  },

  created() {
    this._value = this._value || utils.copy(this.value)
    this._value.label = this._value.label || this.vm.title
    this.endpoint = `${this.api.$.dashboard.widget}/${this.value.id}`
    this.moduleWidthOptions =
      this.value.variableDefinitions
        ? this.value.variableDefinitions[0].items
          .map(option => {
            return {
              label: option.label,
              value: WIDTHS[option.key]
            }
          })
        : this.defaultModuleWidthOptions
  },

  data() {
    return {
      placeholders: SETTING_PLACEHOLDERS,
      vm: {
        ...utils.copy(this.options)
        // moduleWidth: this.getWidth()
      },

      operations: {
        savePending: false,
        clonePending: false,
        deletePending: false
      },
      widthInvalid: false,
      availableSettings: this.value.variableDefinitions || [],
      settings: this.value.variables && utils.copy(this.value.variables) || []
    }
  },

  computed: {
    moduleWidth: {
      get() { return this.getWidth() },
      set(v) {
        this._value.w = v.value
        this.pickedWidth = true

        // update width
        if (this.settings[0]) {
          this.settings[0].value = this.getWidthKey(v.value)
        }
      }
    },

    currencies() { return global.app.$user.sessionSettings.Currencies }
  },

  methods: {
    set() {
      // set width
      if (this.pickedWidth) {
        // do not update width immediately
        // this.value.w = this._value.w
        this.pickedWidth = false
      }
      this._value.variables = this.settings

      this.$nextTick(() => {
        this.operations.savePending = true
        this.$emit('set',
          {
            value: this._value,
            moduleWidth: this.getWidth(),
            ...utils.copy(this.vm)
          }
        )
      })
    },

    closeOptions() {
      EventBus.$emit('widgetSettingsClose', this)
    },

    getValue(i, from) {
      const option = from
                      ? this[from].filter(k => k.key === this.settings[i].value[0])
                      : this.availableSettings[i].items.filter(k => k.key === this.settings[i].value[0])
      return option && option[0] && option[0].label
    },

    setValue(v, i) {
      v && this.$nextTick(() => {
        this.settings[i].value = [v.key]
      })
    },

    clone() {
      this.$nextTick(() => {
        this.operations.clonePending = true
        this.$parent.$emit('clone')
      })
    },

    remove() {
      this.$nextTick(() => {
        this.operations.deletePending = true
        this.$parent.$emit('remove')
      })
    },

    getWidth() {
      const option = this.moduleWidthOptions &&
                     this.moduleWidthOptions.filter(k => k.value === this._value.w)[0]

      const width = {
        label: option ? option.label : '%',
        value: this._value.w
      }

      if (this.settings && this.settings[0]) {
        if (option) {
          this.widthInvalid = false
          this.settings[0].value = this.getWidthKey(option.value)
        } else {
          this.widthInvalid = true
        }
        return this.settings[0].value && width
      } else {
        return width
      }
    },

    optionComponent: (type) => Vue.component(SELECTOR_COMPONENTS[type]),

    relevantToDisplay(option) {
      let relevantOption =
        option.items.length !== 1 &&
        this.optionComponent(option.type) !== 'ed-radio'

      return relevantOption
    },

    getWidthKey(value) {
      return Object.keys(WIDTHS).filter(k => WIDTHS[k] === value)
    }
  }
}

</script>

<style scoped lang='scss'>

.option-group {
    margin-left: 5px;
  .form-group {
    padding-left: 0;
  }

  .option-label {
    margin-bottom: 0;
  }

  .col-md-7 {
    width: 90%;
  }
}
a:hover{
  background-color: white !important;
  color: black !important;
}

.close-icon {
  color: black !important;
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/SharedComponents/WidgetOptions.vue